import { CardContent, css } from '@mui/material';
import styled from '@emotion/styled/macro';

import {
  BLOCKED,
  CANCELLED,
  CLOSED,
  DECLINED,
  NEW,
  PARTIALLY_CLOSED,
  REIMBURSEMENT_ACKNOWLEDGED,
  WAITING_FOR_INFORMATION,
  WAITING_FOR_PAYOUT,
} from '../../shared/claimStatus';

export const StyledClaimCardContent = styled(CardContent)(
  ({ theme, statusUpdated }) => css`
    align-items: center;
    border: ${statusUpdated ? `2px solid ${theme.palette.main.professional_blue}` : 'none'};
    border-radius: 4px;
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    padding: ${theme.spacing('LARGE')};
  `
);

export const StyledClaimCardContentTextContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    row-gap: ${theme.spacing('SMALL')};
  `
);

const claimStatusLabelCSS = ({ theme, claimStatus }) => {
  switch (claimStatus) {
    case BLOCKED:
      return css`
        background-color: ${theme.palette.error.main};
        color: ${theme.palette.common.white};
      `;

    case REIMBURSEMENT_ACKNOWLEDGED:
    case WAITING_FOR_PAYOUT:
    case PARTIALLY_CLOSED:
    case CLOSED:
    case CANCELLED:
      return css`
        color: ${theme.palette.common.white};
        background-color: ${theme.palette.success.main};
      `;

    case DECLINED:
      return css`
        border: 1px solid ${theme.palette.main.professional_blue};
      `;

    case NEW:
    case WAITING_FOR_INFORMATION:
    default:
      return css`
        background-color: ${theme.palette.main.product_blue};
        color: ${theme.palette.common.white};
      `;
  }
};

export const StyledClaimStatus = styled('div')(
  ({ theme, claimStatus }) => css`
    align-self: flex-start;
    padding: 0.25em 0.375em;
    color: ${theme.palette.main.professional_blue};
    border-radius: 5px;
    ${claimStatusLabelCSS({ theme, claimStatus })};
  `
);
